var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useMemo } from 'react';
import { apiGetOneArticleTotal } from '@/actions/ArticleActions';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { ARTICLE_PAGE_LINK_CASE, ARTICLE_PAGE_LINK_COLUMN, ARTICLE_PAGE_LINK_DOCUMENT, ARTICLE_PAGE_LINK_SEMINAR, } from '@/utils/constants/article/articleLink';
import { SESSION_STORAGE_KEY_ARTICLE_COUNT } from '@/utils/constants/storage/sessionStorageKey';
import { useSessionStorage } from '@/utils/libs/react-hookz/useSessionStorage';
/**
 * 記事一覧ページ用の各件数情報を取得するカスタムフック
 */
export const useArticleListFetchCount = (args) => {
    const { dispatch, pathname, unmountRef } = args;
    // 各種記事件数
    const { set: changeArticleCount, value: articleCount } = useSessionStorage(SESSION_STORAGE_KEY_ARTICLE_COUNT, {
        defaultValue: {},
    });
    /**
     * 各記事の件数を取得
     */
    const fetchArticleCounts = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        // APIから各記事の件数を取得
        const { payload } = yield wrapDispatch(dispatch, apiGetOneArticleTotal({}, {}));
        if (!unmountRef.current) {
            // 取得した件数をstateに反映
            changeArticleCount(payload);
        }
    }), [dispatch, unmountRef, changeArticleCount]);
    // 件数リンクタブ表示用の値
    const articleLinkListItems = useMemo(() => [
        Object.assign(Object.assign({}, ARTICLE_PAGE_LINK_CASE), { count: articleCount === null || articleCount === void 0 ? void 0 : articleCount.support_examples_count }),
        Object.assign(Object.assign({}, ARTICLE_PAGE_LINK_DOCUMENT), { count: articleCount === null || articleCount === void 0 ? void 0 : articleCount.documents_count }),
        Object.assign(Object.assign({}, ARTICLE_PAGE_LINK_COLUMN), { count: articleCount === null || articleCount === void 0 ? void 0 : articleCount.columns_count }),
        Object.assign(Object.assign({}, ARTICLE_PAGE_LINK_SEMINAR), { count: articleCount === null || articleCount === void 0 ? void 0 : articleCount.seminars_count }),
    ].map((item) => (Object.assign(Object.assign({}, item), { isActive: item.to === pathname }))), [articleCount, pathname]);
    // 各種件数を取得
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchArticleCounts();
        }))();
    }, [dispatch, fetchArticleCounts]);
    return {
        // 件数タブリンク表示用のデータ
        articleLinkListItems,
    };
};
